import { axiosMicroservice } from 'src/api/axios';

export type TpGenerateBraintreeClientToken = {
  customerId: string | number;
  customerEmail: string;
  merchantAccountId: string | number;
  app?: string;
};

export const generateBraintreeClientToken = async ({
  customerId,
  customerEmail,
  merchantAccountId,
  app = 'Youth',
}: TpGenerateBraintreeClientToken): Promise<string> => {
  const { data } = await axiosMicroservice.post(
    'braintree_generate_client_token',
    {
      app,
      user_id: customerId,
      email: customerEmail,
      merchant_account_id: merchantAccountId,
    },
  );
  return data;
};
